import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useEquitiesMode } from '../hooks/useEquitiesMode';

const BLOCKED_PREFIXES = [
  '/trade/crypto',
  '/trade/forex',
  '/trade/futures',
  '/autonomy',
  '/verticals/crypto',
  '/verticals/forex',
  '/verticals/futures',
];

/**
 * Redirects legacy multi-asset routes to stocks workspace when equities-only.
 */
export default function EquitiesRouteGuard({ children }: { children: React.ReactNode }) {
  const { equities_only } = useEquitiesMode();
  const location = useLocation();

  if (equities_only) {
    const path = location.pathname.toLowerCase();
    if (path === '/autonomy' || BLOCKED_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`))) {
      return <Navigate to="/trade/stocks/overview" replace />;
    }
    if (path === '/verticals' || path.startsWith('/verticals/')) {
      if (!path.startsWith('/verticals/stocks')) {
        return <Navigate to="/trade/stocks/overview" replace />;
      }
    }
  }

  return <>{children}</>;
}
